/**
 * <custom-build-gallery> - CSS Grid + native <dialog> lightbox.
 * Uses native <dialog> for focus trap; no external lightbox library.
 */
(function () {
  'use strict';
  if (customElements.get('custom-build-gallery')) return;

  var CustomBuildGallery = function () { HTMLElement.apply(this, arguments); };
  CustomBuildGallery.prototype = Object.create(HTMLElement.prototype);
  CustomBuildGallery.prototype.constructor = CustomBuildGallery;

  CustomBuildGallery.prototype.connectedCallback = function () {
    var self = this;
    this.dialog = this.querySelector('[data-lightbox]');
    this.img = this.querySelector('[data-lightbox-image]');
    this.caption = this.querySelector('[data-lightbox-caption]');
    this.closeBtn = this.querySelector('[data-lightbox-close]');
    this.prevBtn = this.querySelector('[data-lightbox-prev]');
    this.nextBtn = this.querySelector('[data-lightbox-next]');
    this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
    this.index = 0;

    if (!this.dialog || !this.img || this.slides.length === 0) return;

    this.querySelectorAll('.custom-build-gallery__item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.index, 10) || 0;
        self._open(idx);
      });
    });

    this.closeBtn && this.closeBtn.addEventListener('click', function () { self._close(); });
    this.prevBtn && this.prevBtn.addEventListener('click', function () { self._go(-1); });
    this.nextBtn && this.nextBtn.addEventListener('click', function () { self._go(1); });

    // Keyboard nav when dialog open
    this.dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self._go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self._go(1); }
    });

    // Click backdrop to close
    this.dialog.addEventListener('click', function (e) {
      if (e.target === self.dialog) self._close();
    });

    // Swipe on mobile
    var touchStartX = 0;
    this.dialog.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    this.dialog.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(dx) > 50) self._go(dx < 0 ? 1 : -1);
    }, { passive: true });
  };

  CustomBuildGallery.prototype._render = function () {
    var slide = this.slides[this.index];
    if (!slide) return;
    this.img.src = slide.dataset.src;
    this.img.alt = slide.dataset.alt || '';
    this.caption.textContent = slide.dataset.caption || '';
    // Update nav button state
    if (this.prevBtn) this.prevBtn.hidden = this.slides.length < 2;
    if (this.nextBtn) this.nextBtn.hidden = this.slides.length < 2;
  };

  CustomBuildGallery.prototype._open = function (idx) {
    this.index = Math.max(0, Math.min(idx, this.slides.length - 1));
    this._render();
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  };

  CustomBuildGallery.prototype._close = function () {
    if (typeof this.dialog.close === 'function') {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
    }
  };

  CustomBuildGallery.prototype._go = function (delta) {
    var n = this.slides.length;
    this.index = (this.index + delta + n) % n;
    this._render();
  };

  customElements.define('custom-build-gallery', CustomBuildGallery);
})();
